import React from 'react'
import { Select } from 'elentari'
import { Field } from 'react-final-form'

const CorAvisoSelect = props => {
  return (
    <Field
      fullWidth
      hideEmpty
      name="cor"
      component={Select}
      options={[
        { label: 'Verde', value: 'success' },
        { label: 'Amarelo', value: 'warning' },
        { label: 'Vermelho', value: 'error' }
      ]}
      label="Cor"
      {...props}
    />
  )
}

export default CorAvisoSelect
